import { StateCreator } from "zustand";
import { MandatoryVideoMetaData, VideoMetadataSlice } from "./types";
import { Store } from "../../types";

export const createVideoMetadataSlice: StateCreator<
  Store,
  [],
  [],
  VideoMetadataSlice
> = (set) => ({
  videoAssets: {},
  initializeVideoMetadata: (upload) => {
    const assets = upload.assets.reduce(
      (relatedAssets, asset) => {
        const { relatedAssetMetadata, originalName = null } = asset;
        if (!relatedAssetMetadata) {
          return relatedAssets;
        }
        const assetMetadata = {
          ...relatedAssetMetadata,
          validationMessage: [],
          originalName,
        };

        relatedAssets[relatedAssetMetadata.assetId] = assetMetadata;
        return relatedAssets;
      },
      {} as Record<number, MandatoryVideoMetaData>,
    );
    set({
      videoAssets: assets,
    });
  },
  setVideoMetaData: (key, videoMetadata) => {
    set((state) => ({
      videoAssets: {
        ...state.videoAssets,
        [key]: {
          ...state.videoAssets[key],
          ...videoMetadata,
        },
      },
    }));
  },
  setRelatedAssets: (key, relatedAssets) =>
    set((state) => ({
      videoAssets: {
        ...state.videoAssets,
        [key]: {
          ...state.videoAssets[key],
          relatedAssets,
        },
      },
    })),
  setVideoMetadataValidation: (key, validationMessage) =>
    set((state) => ({
      videoAssets: {
        ...state.videoAssets,
        [key]: {
          ...state.videoAssets[key],
          validationMessage,
        },
      },
    })),
  resetVideoValidationError: (key, field) =>
    set((state) => {
      const asset = state.videoAssets[key];
      if (!asset) return state;

      const updatedValidationMessages = asset.validationMessage.filter(
        (msg) => msg.field !== field,
      );

      return {
        videoAssets: {
          ...state.videoAssets,
          [key]: {
            ...asset,
            validationMessage: updatedValidationMessages,
          },
        },
      };
    }),
});
